import {NativeId} from '@packages/systems/core/utils/NativeIdUtils';

type IsEditingComponentInContextArgs = {
  isComponentCanvasActive: boolean;
  focusedSymbolNativeIdPath: NativeId[];
};

/**
 * Returns true when editing a component instance in context, otherwise false.
 *
 * When the Component Canvas is active, the function returns true when the user entered component editing by choosing in-context editing.
 * When the Component Canvas is inactive, the function returns true when any user component is being edited (the Designer's default method of editing components)
 */
export const isEditingComponentInContext = ({
  isComponentCanvasActive,
  focusedSymbolNativeIdPath,
}: IsEditingComponentInContextArgs) => {
  if (isComponentCanvasActive) {
    return focusedSymbolNativeIdPath.length > 1;
  } else {
    return focusedSymbolNativeIdPath.length > 0;
  }
};
